import Profile from './containers/Profile';
import Stance from '../stance/containers/Stance';
import MyUserStance from '../stance/containers/MyUserStance';
import Gripsize from '../gripsize/containers/Gripsize';
import MyUserGripsize from '../gripsize/containers/MyUserGripsize';
import MyUsers from '../my-users/containers/MyUsers';
import AddCustomer from '../my-users/containers/AddCustomer';
import ChangePassword from '../change-password/containers/ChangePassword';
import ProfileEdit from './containers/ProfileEdit';
import ProfileDetails from './containers/ProfileDetails';

export const profileRoutes = {
    path: '/profile',
    component: Profile,
    indexRoute: { component: ProfileDetails },
    childRoutes: [
        { path: '/profile/stance', component: Stance },
        { path: '/profile/stance/:username', component: MyUserStance },
        { path: '/profile/gripsize', component: Gripsize },
        { path: '/profile/gripsize/:username', component: MyUserGripsize },
        { path: '/profile/users', component: MyUsers },
        { path: '/profile/users/add', component: AddCustomer },
        { path: '/profile/change-password', component: ChangePassword },
        { path: '/profile/:username/edit', component: ProfileEdit }
    ]
}


// WEBPACK FOOTER //
// ./src/profile/routes.js